import { Flex } from '@mantine/core'

import { Insight } from '@/components/Insight/Insight'
import { Loader } from '@/components/Loader/Loader'

import type { page as InsightPage } from '@/__generated__/requests'

import { useInsightsQuery } from '@/hooks/useInsightsQuery.hook'

export function Insights({
  page,
  staticMargin = false,
}: {
  page: InsightPage
  staticMargin?: boolean
}) {
  const { data, isFetching, isLoading } = useInsightsQuery(page)

  const insights = data?.insights ?? []

  if (isFetching || isLoading) {
    return (
      <Flex mb={24}>
        <Loader isMinimized />
      </Flex>
    )
  }

  if (!insights.length) {
    return null
  }

  return (
    <Flex
      align={{
        base: 'flex-start',
        sm: 'stretch',
      }}
      direction={{
        base: 'column',
        sm: 'row',
      }}
      gap={16}
      justify="center"
      mb={staticMargin ? 24 : 0}
    >
      {insights.map(insight => (
        <Insight key={insight.dedupeKey} {...insight} />
      ))}
    </Flex>
  )
}
